import React from "react";

export const Logo = ({ size = "md", withText = true, className = "" }) => {
  const sizes = { sm: 28, md: 36, lg: 48, xl: 64 };
  const px = sizes[size] || sizes.md;

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div
        className="relative shrink-0 rounded-full overflow-hidden"
        style={{
          width: px,
          height: px,
          border: "1px solid rgba(212,165,116,0.35)",
        }}
      >
        <img
          src="/logo.png"
          alt="Vachhraj Estate"
          className="w-full h-full object-cover"
          style={{ objectPosition: "center" }}
        />
      </div>
      {withText && (
        <div className="leading-none">
          <div
            className="text-[1.05rem] md:text-[1.15rem]"
            style={{
              fontFamily: "Fraunces, serif",
              color: "var(--terra-500)",
              letterSpacing: "0.02em",
              fontWeight: 500,
            }}
          >
            VACHHRAJ
          </div>
          <div
            className="text-[0.62rem] md:text-[0.7rem] tracking-[0.35em]"
            style={{
              color: "var(--gold-500)",
              fontFamily: "Inter Tight, sans-serif",
              marginTop: "2px",
            }}
          >
            ESTATE
          </div>
        </div>
      )}
    </div>
  );
};

export default Logo;